import api from "./config";
import { API_ENDPOINTS } from "../../utils/constants";
const authApi = {
  RegisterCustomer: async (data) => {
    var response = await api.put(API_ENDPOINTS.REGISTER_CUSTOMER, data);
    return response.data;
  },
  ForgotPassword: async (email) => {
    var response = await api.get(`${API_ENDPOINTS.FORGOT_PASSWORD}?email=${email}`);
    return response.data;
  },


  ResetPassword: async (data) => {
    var response = await api.put(API_ENDPOINTS.RESET_PASSWORD, data);
    return response.data;
  },

  Login: async (data) => {
    var response = await api.post(API_ENDPOINTS.LOGIN, data);
    return response.data;
  },

  TwoFactorLogin: async (data) => {
    var response = await api.post(API_ENDPOINTS.TWO_FACTOR_LOGIN, data);
    return response.data;
  },

};

export default authApi;
